import { Select } from "antd";
import React from "react";
import { USER_STATUS_INFO } from "../../../constants/constant";

const UsersLookup = (props) => {
    return (
        <>
            <Select
                {...props}
                style={{ width: "150px" }}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                allowClear
            >
                {USER_STATUS_INFO?.map((data) => {
                    return (
                        <Select.Option key={data?.id} value={data.value}>
                            {data?.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default UsersLookup;
